import { render, staticRenderFns } from "./datePickerType.vue?vue&type=template&id=487b6baf"
import script from "./datePickerType.vue?vue&type=script&lang=js"
export * from "./datePickerType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports